'use strict'

import { componentName as rundownItemComponentName, RundownPrepItem } from '../../../components/RundownPrepItem.js'
import { sortRundownItems } from '../../../functions/sortRundownItems.js'
import { removeElement, insertBeforeElement } from '../../../functions/dom.js'
import yItemsLoop from '../classes/yItemsLoop.js'

export default [
    function () {

        return {
            templateUrl: '/partial/app.partials.rundown.directives.preps',
            replace: true,
            controller: [
                '$element',
                '$scope',
                '$state',
                'widgets',
                'userSettings',
                rmRundownPrepsCtrl
            ],
            controllerAs: 'ctrl',
            scope: {
                yBlocks: '=',
                blocks: '=',
                roomName: '=',
                rundownInfo: '=',
                currentFilters: '=',
                readOnly: '=',

                itemModelTypes: '='
            },
            link: function (scope, element, attributes, controllers) {

            }
        }
    }
]

class rmRundownPrepsCtrl extends yItemsLoop {
    constructor ([$element], $scope, $state, widgets, userSettings) {
        super()

        this.$element = $element
        this.$scope = $scope
        this.$state = $state
        this.widgets = widgets

        $scope.yItems = {}
        this.rundownInfo = $scope.rundownInfo
        this.ownerStationId = $scope.rundownInfo.masterstation_id || window.CONFIG.station_id
        this.readOnly = $scope.readOnly
        this.currentFilters = $scope.currentFilters

        this.blocks = {}

        const userSettingsListener = this.userSettingsListener.bind(this)

        userSettings.addListener(userSettingsListener)

        $scope.$on('$destroy', () => {
            userSettings.removeListener(userSettingsListener)

            for (const blockId in this.blocks) {
                if (!this.blocks.hasOwnProperty(blockId)) continue
                this.blocks[blockId].destroy()
            }
        })
    }

    userSettingsListener (settings) {
        const { classList } = this.$element
        classList.toggle('rundownPreps-hideCheckbox', !settings.checkbox)
        classList.toggle('rundownPreps-hideTime', !settings.time)
    }

    initBlock (block) {
        const { $scope } = this
        const unRegister = $scope.$watch(
            () => {
                if ($scope.yBlocks[block.id] && $scope.yBlocks[block.id].get('items')) {
                    return $scope.yBlocks[block.id]
                }
                return null
            },
            yBlock => {
                if (yBlock && yBlock.observeDeep) {

                    unRegister()

                    const calculateOverTimesDebounce = _.debounce(() => {
                        for (const element of Array.from(blockItemsContainer.children)) {
                            if (element instanceof RundownPrepItem) {
                                element.calculateDurationOverTime()
                                element.calculateOverTime()
                            }
                        }
                    }, 2000, { maxWait: 5000 })

                    const diffBlockItems = () => {
                        const yItems = this.getItemsFromYBlock(yBlock)
                        let sortItemsAgain = false

                        let i = 0
                        // Check the order is still correct. Reorder the items when there is an item in the wrong place
                        const blockItemsChildren = Array.from(blockItemsContainer.children)
                        for (const element of blockItemsChildren) {
                            if (element instanceof RundownPrepItem) {
                                if (yItems[i] !== element.yItem) {
                                    sortItemsAgain = true
                                }

                                i++
                            }
                        }

                        // Also reorder when the length of the yArray is not tha same of the found elements
                        if (i !== yItems.length) {
                            sortItemsAgain = true
                        }

                        for (const element of blockItemsChildren) {
                            if (element.yItem) {
                                const itemIndex = yItems.indexOf(element.yItem)

                                if (itemIndex === -1) {
                                    removeElement(element)
                                    sortItemsAgain = true
                                } else {
                                    yItems.splice(itemIndex, 1)
                                }
                            }
                        }

                        // Now all the ids in yItemIds are new created items
                        for (const yItem of yItems) {
                            if (!yItem.get('id')) continue
                            blockItemsContainer.appendChild(this.createItem(block.id, yItem))
                            sortItemsAgain = true
                        }

                        if (sortItemsAgain) {
                            sortItems.flush()
                        }
                    }

                    const itemUpdateDiffInterval = setInterval(diffBlockItems, 1000)

                    const blockItemsContainer = this.$element.querySelector('#items-' + block.id)
                    const yItemArray = this.getItemsFromYBlock(yBlock)

                    const sortItems = _.debounce(() => {
                        if (yBlock.get('items').length !== 0) {

                            const currentIndexes = Array.from(blockItemsContainer.children)
                                .map((node, index) => {
                                    if (node.id === '' || node.localName !== rundownItemComponentName) {
                                        node.remove()
                                        return null
                                    }

                                    return {
                                        order: node.getAttribute('data-order'),
                                        nodeId: node.id,
                                        index: index
                                    }
                                })
                                .filter(value => !!value)

                            const indexesSorted = sortRundownItems(currentIndexes)

                            let orderHasBeenUpdated = false
                            let cursorIndex = 0
                            for (const { nodeId } of indexesSorted) {
                                const placeNode = blockItemsContainer.children[nodeId]
                                const currentNode = blockItemsContainer.children[cursorIndex]

                                if (!currentNode) break
                                if (currentNode.id !== nodeId) {
                                    orderHasBeenUpdated = true
                                    insertBeforeElement(currentNode, placeNode)
                                }

                                cursorIndex++
                            }

                            if (orderHasBeenUpdated) {
                                calculateOverTimesDebounce()
                            }
                        }
                    }, 1000)

                    this.blocks[block.id] = {
                        calculateOverTimesDebounce,
                        yBlock, block, sortItems,
                        destroy: () => {
                            clearInterval(itemUpdateDiffInterval)
                        }
                    }

                    for (const yItem of yItemArray) {
                        if (!yItem.get('id')) continue
                        blockItemsContainer.appendChild(
                            this.createItem(block.id, yItem)
                        )
                    }

                    setTimeout(sortItems)
                }
            }
        )
    }

    createItem (blockId, yItem) {
        const { $scope, $state, widgets, rundownInfo, ownerStationId } = this
        const { sortItems, calculateOverTimesDebounce } = this.blocks[blockId]
        const { readOnly } = $scope

        const itemContainer = document.createElement(rundownItemComponentName)

        itemContainer.addEventListener('open-edit', () => {
            $state.go('.edit', { blockId, type: 'block', itemId: yItem.get('id') })
        })

        itemContainer.addEventListener('calculate-block-overtimes', () => {
            calculateOverTimesDebounce()
        })

        const scrollContainer = this.$element
        Object.assign(itemContainer, {
            yItem, sortItems, readOnly, widgets,
            rundownInfo, ownerStationId, scrollContainer
        })

        return itemContainer
    }
}
